import { faMapMarkerAlt } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Table, Typography } from "antd"
import type { ColumnsType } from "antd/es/table"
import dayjs from "dayjs"
import { useState } from "react"
import { CustomerVisit } from "./customerVisitsApi"
import { projectTypeLabel } from "./customerVisitsModel"
import { useCustomerVisitsQuery } from "./customerQueries"

const { Text } = Typography

const PAGE_SIZE = 25

type Props = {
  customerId: number
}

const columns: ColumnsType<CustomerVisit> = [
  { title: 'Date', key: 'date', render: (_, v) => (v.date ? dayjs(v.date).format('MMM D, YYYY') : '') },
  { title: 'Project Type', key: 'type', render: (_, v) => projectTypeLabel(v.project?.type) },
  { title: 'Created By', dataIndex: 'createdByEmail', key: 'createdByEmail' },
  { title: 'Project Name', key: 'projectName', render: (_, v) => v.project?.name },
]

const CustomerVisitsTable = ({ customerId }: Props) => {
  const [page, setPage] = useState(1)
  const visitsQuery = useCustomerVisitsQuery(customerId, page, PAGE_SIZE)

  const visits = visitsQuery.data?.data ?? []
  const total = visitsQuery.data?.recordsTotal ?? 0

  return <div>
    <Text strong><FontAwesomeIcon icon={faMapMarkerAlt} /> Customer Visits</Text>
    <Table
      rowKey="id"
      columns={columns}
      dataSource={visits}
      loading={visitsQuery.isLoading || visitsQuery.isFetching}
      size="small"
      style={{ marginTop: 8 }}
      pagination={{
        current: page,
        pageSize: PAGE_SIZE,
        total,
        onChange: setPage,
        showSizeChanger: false,
      }}
    />
  </div>
}

export default CustomerVisitsTable
